import { IWebsiteBuilderMigrationNode } from "./migrationNode";

export function migrateTraversal(
  node: IWebsiteBuilderMigrationNode,
  migrateNode: (prev: IWebsiteBuilderMigrationNode) => IWebsiteBuilderMigrationNode,
): IWebsiteBuilderMigrationNode {
  function traverse(node: IWebsiteBuilderMigrationNode): IWebsiteBuilderMigrationNode {
    const migratedNode = migrateNode(node);
    
    if (migratedNode.children != null) {
      return {
        ...migratedNode,
        children: migratedNode.children.map(traverse),
      };
    } else {
      return migratedNode;
    }
  }

  return traverse(node);
}